import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Modal, notification} from "antd";
import {bindActionCreators} from "redux";
import {endStockTake} from "./actions";
import {getDescriptionFromError} from "../utils/errors";

class EndStockTakeModal extends React.Component {
  static propTypes = {
    //
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    stockTake: PropTypes.object,
    //
    endingStockTake: PropTypes.bool.isRequired,
    //
    endStockTake: PropTypes.func.isRequired,
  };

  render() {
    const {visible, onClose, stockTake, endingStockTake} = this.props;
    const {stockTakeId, counted, uncounted, discrepancies, adjusted} = stockTake || {};
    return (
      <Modal
        visible={visible}
        title="End Stock-take"
        okText="End"
        onOk={async() => {
          try {
            await this.props.endStockTake({stockTakeId});
            onClose(true);
          } catch (err) {
            notification.error({
              message: 'Failed',
              description: getDescriptionFromError(err),
            });
          }
        }}
        okButtonProps={endingStockTake ? {disabled: true} : {disabled: false}}
        onCancel={() => onClose(false)}
        cancelButtonProps={endingStockTake ? {disabled: true} : {disabled: false}}
      >
        Please confirm that you want to end this stock take with the current status:
        <ul>
          <li>{counted} SKU counted</li>
          <li>{uncounted} SKU uncounted</li>
          <li>{discrepancies} discrepancies found</li>
          <li>{adjusted} discrepancies adjusted</li>
        </ul>
      </Modal>
    );
  }
}

export default connect(
  state => ({
    endingStockTake: state.stockTake.endingStockTake,
  }),
  dispatch => bindActionCreators({endStockTake}, dispatch),
)(EndStockTakeModal);


// WEBPACK FOOTER //
// ./src/StockTake/EndStockTakeModal.js